interface SendCodeResponse {
  success: boolean;
  error?: string;
  details?: string;
}

interface VerifyCodeResponse {
  success: boolean;
  error?: string;
  details?: string;
}

export async function sendVerificationCode(phoneNumber: string): Promise<SendCodeResponse> {
  try {
    const response = await fetch('/api/auth/mfa/send-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send verification code');
    }

    return { success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error.message,
      details: error.toString()
    };
  }
}

export async function verifyCode(phoneNumber: string, code: string, locale: string = 'en'): Promise<VerifyCodeResponse> {
  try {
    const response = await fetch('/api/auth/mfa/verify-code', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber, code, locale }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Invalid verification code');
    }

    return { success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error.message,
      details: error.toString()
    };
  }
}
